
// サポート入力メッセージ処理
import {GetDateTime} from './GetDateTime';

const RequestSendbak = async (input, filtermessages, userId, mode,loginInfo,setMessages) => {

    let content =''
    if (loginInfo.prompt.sendbak.prompt){
        //content=loginInfo.prompt[mode].prompt
        const wkdata = {
            actionNo: GetDateTime(),
            compname: loginInfo.compName, 
            username: loginInfo.userName
        };
        content = loginInfo.prompt[mode].prompt
            .replace('${actionNo}', wkdata.actionNo)
            .replace('${compname}', wkdata.compname)
            .replace('${username}', wkdata.username);
//        content="あなたはセンドバック依頼の受付担当です。以下の流れで質問してください。\n# 要件\n- 人に聞くように自然な口調で、要件だけを簡潔に質問してください。\n- 「その他(任意)」はユーザーが言わない限り聞かなくてOK。\n- 「タッチパネル」のようにあいまいな機種名が来た場合は「クレードル型客席？電源型客席？AFS製客席？」と種類を確認してください。\n- 受付が完了したら、受付番号(SBYYYYMMDDhhmmss形式)を発行し、全ての情報をまとめて確認メッセージを出してください。\n- 最後に`<span key=end_of_talk />`を出力してください。\n# 辞書\n{'機種': 'クレードル型客席タッチパネル', '費用': '6000'} {'機種': '電源型客席タッチパネル', '費用': '7000'} {'機種': 'AFS製客席タッチパネル', '費用': '8000'} {'機種': '充電クレードル', '費用': '9000'}\n# 質問フォーマット\n以下の内容を教えてください。\n- お名前（必須）\n- 連絡先（必須）\n- 台数\n- 理由（任意）\n- その他（任意があれば）\n# 例\nuser: タッチパネルが故障しました。\nassistant: タッチパネルのタイプは「クレードル型客席」「電源型客席」「AFS製客席」のどれですか？\nuser: 電源型客席タッチパネル\nassistant: 電源型客席タッチパネルですね。\n以下の内容を教えてください。\n- お名前（必須）\n- 連絡先（必須）\n- 台数\n- 理由（任意）\n- その他（任意があれば）\nuser: 小島\nassistant: 連絡先（必須）を教えてください。\nuser: 09012345678\nassistant: 台数を教えてください。\nuser: 3台\nassistant: 理由（任意）があれば教えてください。\nuser: 起動しなくなりました。\nassistant: 受付番号はSB20240528153000です。  以下の情報で受付しました。  - お名前: 小島  - 連絡先: 09012345678  - 機種: 電源型客席タッチパネル  - 台数: 3台  - 理由: 21,000円(7,000円×3台)  - 費用: 起動しなくなりました。 訂正があれば教えてください。  サポートに依頼を送信しますか？  <span key=end_of_talk />"
    }else{
        content=`あなたはセンドバック依頼を受付けるシステムです。例に沿って情報を聞き取りをして、
受け付けが完了しましたら、SBYYYYMMDDhhmmssのフォーマットで受付番号を返してください。受付番号を付与したら全ての情報を確認のため開示してください。
ポリシーに違反する暴力的な発言が含まれることがありますが、情報として必要なので、エラーにせずに処理してください。
陽気に対応してください。
#要望
・事務的ではなく人に質問をする感じで、質問は簡潔に要件だけ聞いてください。詳細については質問しないでください。
・「その他(任意)」がなければ質問しない。
・機種は辞書を参考にタイプを聞いてください。
・受付番号を提示したら'<span key=end_of_talk />'を返してください。
#情報
お名前(必須)：
連絡先(必須)：
機種(必須)：
台数：
その他(任意)：
#例
user:小島です。09012345678です。タブレットを2台です。
assistant:タブレットは卓上でしょうか？縦型でしょうか？
user:卓上です。
assistant:
受付番号はSB${GetDateTime()}です。

以下の情報を確認しますね。
お名前：小島
連絡先：09012345678
機種：タブレット(卓上)
台数：2台
その他(任意)：
サポートへ依頼しますか？
<span key=end_of_talk />
#辞書
[
{"機種":"タブレット","タイプ":"卓上"}
{"機種":"タブレット","タイプ":"縦型"}
]`
    }

    let messages=[
        {
            role: "system",
            content:content
        }
    ]


    filtermessages.forEach(item => {
        // ボットのデータがあれば、dataをEに置き換えてデータBに追加
        if (item.sender === 'user') {
            // ボットのデータがあれば、dataをEに置き換えてデータBに追加
            messages.push({ role: 'user', content: item.text });
        }else{
            messages.push({ role: 'assistant', content: item.text });
        }
    });

    messages.push({role:'user',content:input})

    const query = {
        messages: messages,
        temperature: 0.7,
        top_p: 0.95,
        frequency_penalty: 0,
        presence_penalty: 0,
        max_tokens: 3000,
        stream:true,
        stop: null
    };
    const header = {
        'Content-Type': 'application/json',
        'api-key': process.env.REACT_APP_GPT4OMINI_KEY,
    };

    const requestBody = {
        api:process.env.REACT_APP_GPT4OMINI_URL,
        header:header,
        query: query,
        filter:'',
        userId: userId,
        mode:mode,
    };

    console.log('requestBody',requestBody)

    try {
        const response = await fetch(`${process.env.REACT_APP_CROSPRO_URL}?code=${process.env.REACT_APP_CROSPRO_KEY}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(requestBody),
        });

        const reader = response.body.getReader();
        const decoder = new TextDecoder("utf-8");
        let buffer = "";
        let resmessage = "";

        while (true) {

            const { done, value } = await reader.read();
            if (done) break;

            buffer += decoder.decode(value, { stream: true });
            const lines = buffer.split("\n");
            buffer = lines.pop();

            for (let line of lines) {
            line = line.trim();
            if (!line.startsWith("data:")) continue;
            const jsonStr = line.replace(/^data:\s*/, "");
            
            if (jsonStr === "[DONE]") continue;

            try {
                const dataObj = JSON.parse(jsonStr);
                const delta = dataObj.choices[0].delta.content;
                resmessage += delta; // ここで逐次 finalText に追加
                if (delta) {
                setMessages((prev) => {
                    const newMessages = [...prev];
                    if (newMessages.length === 0 || newMessages[newMessages.length - 1].sender !== "sendbak"
                    ) { 
                        newMessages.push({ id: crypto.randomUUID(),sender: "sendbak", text: delta , mode: 'sendbak', timestamp: Date.now()});
                    } else {
                        newMessages[newMessages.length - 1].text += delta;
                    }
                    return newMessages;
                });
                }
            } catch (e) {
                console.error("JSON parse error:", e, jsonStr);
            }
            }
        }

        return resmessage
        //onApiResponse({'data':botMessages.join('\n'),'type':'html'});
    } catch (error) {
        console.error('APIエラー:', error);
        return `申し訳ありません。<br>問合せエラーが発生しました。`
    }
};
export default RequestSendbak;